module.exports = __webpack_public_path__ + "assets/images/wallet.0af18942c9dda21ec7c6fcd622fdd1e8.png";